import { logApiError, logError } from '../utils/errorLogging';
import { API_ENDPOINTS } from '../constants/api';

export const sendContactEnquiry = async (formData) => {
  const apiEndpoint = API_ENDPOINTS.sendEnquiry;

  try {
    const response = await fetch(apiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
      credentials: 'include'
    });

    const data = await response.json();

    if (!response.ok) {
      logApiError(apiEndpoint, response.status, data.message || response.statusText);
      // Return the actual error message from the API (includes rate limit messages)
      return {
        success: false,
        message: data.message || `API Error: ${response.status} ${response.statusText}`
      };
    }

    return data;
  } catch (error) {
    logError(error, 'CONTACT_SERVICE', { endpoint: apiEndpoint });
    // Only show generic network error if we actually can't reach the API
    const errorMessage = error instanceof TypeError
      ? 'Network error. Please check your connection and try again.'
      : error.message || 'Failed to send enquiry. Please try again.';

    return {
      success: false,
      message: errorMessage
    };
  }
};
